// extracted by mini-css-extract-plugin
export default {"newBadge":"StepBadge_newBadge__nCicZ","closedBadge":"StepBadge_closedBadge__xwYQh","temporary":"StepBadge_temporary__W3VIf"};